import React from "react"
import { observer } from "mobx-react"
import { Checkbox, Flex, Typography } from "antd"

import { onboardingStore } from "@src/widgets/onboarding/classes"
import {
  ONBOARDING_STEPS_LIST,
  ONBOARDING_TOURS_LABEL_MAP,
} from "@src/widgets/onboarding/constants"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export const SelectToursStepUi = () => {
  const store = onboardingStore()

  return (
    <Flex gap={16} vertical>
      <Checkbox.Group
        defaultValue={[ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP]}
        onChange={(e) => store.setSettings(e)}
      >
        <Flex gap={8} vertical>
          {ONBOARDING_STEPS_LIST.map((name) => (
            <Checkbox
              disabled={name === ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP}
              key={name}
              value={name}
            >
              {ONBOARDING_TOURS_LABEL_MAP[name]}
            </Checkbox>
          ))}
        </Flex>
      </Checkbox.Group>

      <Typography.Paragraph>
        We’d love to help you navigate our service more easily by providing
        relevant tips based on your needs. Please select all the topics that
        interest you from the list below, and we'll guide you through them!
      </Typography.Paragraph>
    </Flex>
  )
}
